import { cn } from "@shared/lib/style";
import { AuthorWithDate } from "@shared/ui/author-with-date";
import { Card } from "@shared/ui/card";

interface StyleCardProps {
  className?: string;
  imageClassName?: string;
  textColor?: string;
  author: string;
  date: string;
  category: string;
  title: string;
  subTitle: string;
  imageUrl: string;
}

export default function StyleCard({
  className,
  imageClassName,
  textColor = "black",
  author,
  date,
  category,
  title,
  subTitle,
  imageUrl,
}: StyleCardProps) {
  return (
    <Card
      className={cn(
        "h-[365px] flex-1 justify-between gap-5",
        "max-sm:h-[390px] max-sm:w-full",
        className,
      )}
      contentWrapperClassName="gap-[20px]"
      extraInfo={
        <AuthorWithDate author={author} date={date} textColor={textColor} />
      }
      image={
        <div
          className={cn(
            "h-[200px] w-full bg-slate-300 max-sm:h-[221px]",
            imageClassName,
          )}
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      }
      subTitle={
        <p
          className={cn(
            "max-sm:text-body-4 line-clamp-2",
            textColor === "white" && "text-white",
          )}
        >
          {subTitle}
        </p>
      }
      title={
        <div
          className={cn(
            "line-clamp-2 flex min-h-[54px] flex-col gap-2.5",
            textColor === "white" && "text-white",
          )}
        >
          <span className="text-body-4 max-sm:text-body-5 block min-h-5">
            {category}
          </span>
          <h4
            className={cn(
              "text-body-1 line-clamp-2 h-[54px] font-semibold",
              "max-sm:text-body-2 max-sm:h-[42px]",
            )}
          >
            {title}
          </h4>
        </div>
      }
    />
  );
}
